const API_URL = window.ENV?.API_URL || "https://api-dev.eegdatahub.com/api/";
export default API_URL;
